export default "__VITE_ASSET__DCz47YUe__"